import React from 'react';
import SalesDocumentEditor from '@/pages/SalesDocuments/SalesDocumentEditor';
import { PROFORMA_INVOICE } from '@/pages/SalesDocuments/documentTypes';

export default function ProformaInvoiceEditorPage() {
  return <SalesDocumentEditor docType={PROFORMA_INVOICE} />;
}
